import FilterDropdownController from "./filter_dropdown_controller";

export default class extends FilterDropdownController {
  static targets = ["error"];

  applyFilters(event) {
    const min = this._visibleFilterInput("min")?.value;
    const max = this._visibleFilterInput("max")?.value;

    if (min && max && Number(min) > Number(max)) {
      event?.preventDefault();
      this.errorTargets.forEach((el) => el.classList.remove("display-none"));
      return;
    }

    this.errorTargets.forEach((el) => el.classList.add("display-none"));
    super.applyFilters();
  }

  resetFilters() {
    this._resetFilterFields();
    this.errorTargets.forEach((el) => el.classList.add("display-none"));
    this.updateFilterState();
    this.submitForm();
  }
}
